<kbm-loading />
@if(crudStatus=='REVIEW'){
<div>
  <kbm-book-review [book]="book()" (editClick)="onEditClick($event)"/>
</div>
}
@if (crudStatus=='UPDATE' || crudStatus=='CREATE'){
<div>
  <kbm-book-add-edit [(book)]="book" [crudMode]="crudStatus" (addSaveEvent)="handleAddSaveEvent($event)" />
</div>
}
